module.exports = __webpack_public_path__ + "assets/img/mangguoke_519_1.99d0f074.jpg";